module.exports = __webpack_public_path__ + "static/media/text-icon.abc73124.svg";